export const TAX_SCHEMES = {
  NS: { hst: 0.15 },
  NB: { hst: 0.15 },
  NL: { hst: 0.15 },
  PE: { hst: 0.15 },
  ON: { hst: 0.13 },

  AB: { gst: 0.05 },
  NT: { gst: 0.05 },
  NU: { gst: 0.05 },
  YT: { gst: 0.05 },

  BC: { gst: 0.05, pst: 0.07 },
  SK: { gst: 0.05, pst: 0.06 },
  MB: { gst: 0.05, rst: 0.07 },
  QC: { gst: 0.05, qst: 0.09975 },
};

export function getDefaultTaxes({ province, price = 0 }) {
  const scheme = TAX_SCHEMES[province] || {};
  const taxes = {
    gst: '',
    pst: '',
    qst: '',
    rst: '',
    hst: '',
  };

  Object.entries(scheme).forEach(([key, rate]) => {
    if (price > 0) {
      taxes[key] = (Math.round(price * rate * 100) / 100).toFixed(2);
    }
  });

  return taxes;
}
